
/**
 *      Data-driven UI logic to display search aggregations
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 09/13/2017
 *      Modified on 04/20/2018
 */

/**
 * Show aggregations for a given data type
 * @param type {string} - data type name
 * @param aggregations {Array} - array of aggregation arrays from ES response
 * @param names {[string]} - array of aggregation names from ES response
 * @param filtersLayout {object} - filters layout view
 */
function showTypeAggregations( type, aggregations, names, filtersLayout ) {

    var model;
    if ( type ) {
        model = getDataModel( type, false );
        if ( ! model ) {
            fetchModelForAggregation( type, aggregations, names, filtersLayout );
        } else {
            showAllAggregations( model, aggregations, names, filtersLayout );
        }
    }
}

/**
 * Fetch UI data model from DMR, then display data type aggregations based on the model
 * @param type {string} - data type name
 * @param aggregations {Array} - array of aggregation arrays from ES response
 * @param names {[string]} - array of aggregation names from ES response
 * @param filtersLayout {object} - filters layout view
 */
function fetchModelForAggregation( type, aggregations, names, filtersLayout ) {

    var model;
    if ( type && GlobalPageState && GlobalPageState.models ) {
        model = GlobalPageState.models[ type ];

        // if model has not been fetched yet, retrieve it from DMR and call a display callback
        if ( ! model ) {
            // if call to DMR fails, display an error response
            getJSONUIModel( type, displayDMRAggregations( aggregations, names, filtersLayout ), dataNotFound( "Get JSON UI model for type " + type ) );
        }
    }
}

/**
 * Display all facets (aggregations) for a given data type
 * @param model {object} - data UI JSON model
 * @param aggregations {Array} - array of aggregations
 * @param names {[string]} - array of aggregation names from ES response
 * @param filtersLayout {object} - filters layout view
 */
function showAllAggregations( model, aggregations, names, filtersLayout ) {

    var facet,
        name,
        availableFilters,
        i;

    if ( model && aggregations && names ) {

        availableFilters = $('#available-filters');

        if ( aggregations.length > 0 ) {
            for ( i = 0; i < aggregations.length; i++ ) {
                facet = aggregations[ i ];
                name = names[ i ];
                if ( model ) {
                    // model already exists in the local store
                    showAggregation( facet, model, name, filtersLayout );
                }
            }
        } else {
            var id = "empty-available-filters";
            displayEmptyFilters( filtersLayout, availableFilters, id );
        }

        if ( availableFilters ) {
            if ( availableFilters.children().length === 0 ) {
                availableFilters.css('border-top', 'none');
            } else {
                availableFilters.css('border-top', 'initial');
            }
        }

        showMoreLess( 3, $( '#available-filters > .available-field' ), $( '#showMore' ), $( '#showLess' ) );
        setFooter();
    }
}

/**
 * Show one aggregation for a faceted field
 * @param facet {[object]} - array of facet objects from ES response
 * @param recordModel {object} - UI data model
 * @param name {string} - name of the facet
 * @param filtersLayout {object} - filters layout view
 */
function showAggregation( facet, recordModel, name, filtersLayout ) {

    var filters,
        filter,
        field,
        elementId,
        regionName,
        seeMore,
        seeLess,
        id,
        valueLabels,
        valueLabelValue,
        fieldModel,
        j;

    filters = new FilterCollection();

    if ( recordModel && facet && name ) {

        // nested properties
        fieldModel = getFieldModelByName( recordModel, name );

        for ( j = 0; j < facet.length; j++ ) {
            filter = new FilterModel();
            field = facet[j].key;

            filter.set( "field", field );
            filter.set( "value", numberWithCommas( facet[j].doc_count ) );
            filter.set( "displayValue", field.toString().capitalizeFirstLetter() );

            if ( field === "" ) {
                filter.set( "displayValue", '[ Empty ]' );
            }
            if ( fieldModel ) {
                // Check if options exists in the UI model for that field
                valueLabels = fieldModel.get( "options" );
                if ( valueLabels ) {
                    valueLabelValue = valueLabels[ field ];
                    if ( valueLabelValue ) {
                        filter.set( "displayValue", valueLabelValue );
                    }
                }
            }

            if ( fieldModel ) {
                filter.set( "type", fieldModel.get("type") || FieldTypes.string );
            } else {
                filter.set( "type", "string" );
            }

            filters.add( filter );
        }

        if ( facet.length > 0 ) {
            displayFacets( name, '#available-filters', filtersLayout, filters, fieldModel );

            // add See more / See less buttons to each facet
            elementId = name.replace( ".", "-" );
            seeMore = '<button id="showMore-' + elementId + '" class="btn btn-link show-more" alt="Show all filters" title="Show all filters"><i class="fa fa-plus" alt="Show all filters" title="Show all filters"></i>See more</button>';
            id = '#' + elementId;
            $( id ).append( seeMore );
            seeLess = '<button id="showLess-' + elementId + '" class="btn btn-link show-less" alt="Hide filters" title="Hide filters"><i class="fa fa-minus" alt="Hide filters" title="Hide filters"></i>See less</button>';
            $( id ).append( seeLess );
            regionName = "#" + elementId;
            showMoreLess( 10, $( regionName + ' li.filter-item' ), $( '#showMore-' + elementId ), $( '#showLess-' + elementId ) );
        }
    }
}

/**
 * Return a callback function after UI model has been fetched from DMR to show data type aggregations
 * @param aggregations {Array} - array of aggregation arrays from ES response
 * @param names {[string]} - array of aggregation names from ES response
 * @param filtersLayout {object} - filters layout view
 * @returns {Function}
 */
function displayDMRAggregations( aggregations, names, filtersLayout ) {

    /**
     * Callback that is called when the call to fetch the model from Data Model Registry succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {
        var model = data;
        if ( model ) {
            showAllAggregations( model, aggregations, names, filtersLayout );
        }
    };
}

/**
 * Display top-level data types with their categories
 * @param categories {Array} - sorted array of categories and their types
 * @returns {object} - Backbone.Collection of filters to display
 */
function displayDataTypesAggregation( categories ) {
    var filters = new FilterCollection(),
        i,
        category,
        subtypes,
        subtype,
        dataTypes,
        dataType;


    // The categories array is already sorted
    // Display the items in the same order
    // look at each of the “category” item inside the categories array
    // create a collection of models for each of the categories, sorted by type “position” key-value
    if ( categories && Array.isArray( categories ) ) {
        for ( i = 0; i < categories.length; i++ ) {

            category = categories[ i ];

            if ( category ) {

                // Add category types to the filters collection if it's not empty
                subtypes = category.types;

                if ( subtypes && hasKeys( subtypes ) ) {
                    // Add category to the filters collection
                    filters = pushFilterToCategoryArray( category.label, category.label, null, filters, true );

                    dataTypes = sortDataTypes( subtypes );

                    // Add filters inside the category in proper order
                    for ( subtype in dataTypes ) {
                        if ( dataTypes.hasOwnProperty( subtype )) {
                            dataType = dataTypes[ subtype ];

                            if ( dataType ) {
                                filters = pushFilterToCategoryArray( subtype, dataType.label, dataType.count, filters, false );
                            }
                        }
                    }
                }
            }
        }
    }

    return filters;
}

/**
 * Sort data types object by position field
 * @param types {object} - data types object
 * @returns {object} - sorted data types object
 */
function sortDataTypes( types ) {

    var sortedTypes = {},
        sortedNames,
        i;

    // Define a sort function that returns an array of sorted type names
    sortedNames = Object.keys(types).sort( function( a, b ) {
        return types[ a ].position - types[ b ].position;
    });

    if ( sortedNames ) {
        for ( i = 0; i < sortedNames.length; i++ ) {
            sortedTypes[ sortedNames[i] ] = types[ sortedNames[i] ];
        }
    }

    return sortedTypes;
}